Vue.component('sidebar', {
    template: `
        <div>
            <aside>
                <div class="menu" :class="{'hasShare':loggedUser}">
                    <div class="menuCategory row">
                        <div class="menuHead listHidden">
                            <router-link class="link" active-class="currentPage" :to="'/' + family + '/general'">{{ $language.generalInfos }}</router-link>
                        </div>
                    </div>
                    <div class="menuCategory row">
                        <div class="menuHead" :class="{'listHidden' : !showCompetitors}">

                            <router-link class="link" active-class="currentPage" :to="'/' + family + '/competitors'">{{ $language.competitors }}</router-link>

                            <span class="arrow" v-if="$store.state.competitors.length > 0" @click="toggleCompetitors">
                                <i class="fas fa-chevron-right chevron" :class="{'toDown': showCompetitors}"></i>
                            </span>
                        </div>
                        <div class="menuList" :class="{'menuOpen':showCompetitors}">
                            <div class="listLink"v-if="competitor.ProbablePA" v-for="competitor in $store.state.competitors">
                                <router-link class="listItem" active-class="currentPage" :to="'/' + family + '/assignees/' + competitor.ProbablePA">
                                    {{ competitor.ProbablePA }}
                                </router-link>
                            </div>

                        </div>
                    </div>
                    <div class="menuCategory row">
                        <div class="menuHead" :class="{'listHidden' : !showCpcs}">
                            <router-link class="link" active-class="currentPage" :to="'/' + family + '/technologies'">{{ $language.technologies }}</router-link>

                            <span class="arrow" v-if="classes.length > 0" @click="toggleCpcs">
                                <i class="fas fa-chevron-right chevron" :class="{'toDown': showCpcs}"></i>
                            </span>
                        </div>
                        <div class="menuList" :class="{'menuOpen':showCpcs}">
                            <div class="listLink" v-if="tech" v-for="tech in classes">
                                <router-link class="listItem" active-class="currentPage" :to="'/' + family + '/technologies/' + $store.getters.system + '/' + encodeURIComponent(tech)">
                                    {{ tech }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="menuCategory row">
                        <div class="menuHead listHidden">

                            <router-link class="link" active-class="currentPage" :to="'/' + family + '/assignee'">{{ $language.assigneeOver }}</router-link>

                        </div>
                    </div>
                    <div class="menuCategory row">
                        <div class="menuHead" :class="{'listHidden' : !showInventors}">

                            <router-link class="link" active-class="currentPage" :to="'/' + family + '/inventors'">{{ $language.inventors }}</router-link>

                            <span class="arrow" v-if="$store.state.inventors.length > 0" @click="toggleInventors">
                                <i class="fas fa-chevron-right chevron" :class="{'toDown': showInventors}"></i>
                            </span>
                        </div>
                        <div class="menuList" :class="{'menuOpen':showInventors}">
                            <div class="listLink" v-for="inventor in $store.state.inventors" v-if="inventor" >
                                <router-link class="listItem" active-class="currentPage" :to="'/' + family + '/inventors/' + inventor">
                                    {{ inventor }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="menuCategory row">
                        <div class="menuHead listHidden">

                            <router-link class="link" active-class="currentPage" :to="'/' + family + '/legal'">{{ $language.legalStat }}</router-link>

                        </div>
                    </div>
                    <div class="menuCategory row" v-if="$PVS">
                        <div class="menuHead listHidden">

                            <router-link class="link" active-class="currentPage" :to="'/' + family + '/pvs'">{{ $language.pvs }}</router-link>

                        </div>
                    </div>
                    <div class="explorerLink row">
                        <div class="col-12 text-center">
                            <!--<a @click="openExplorer" data-toggle="tooltip" data-placement="top" :title="$language.familyTooltip">
                                Family explorer&nbsp;<i class="fas fa-external-link-alt"></i>
                            </a>-->
                            <a :href="$setupPath + '../familyExplorer/public/index.php?fn=' + family" target="_blank" data-toggle="tooltip" data-placement="top" :title="$language.familyTooltip">
                                Family explorer&nbsp;<i class="fas fa-external-link-alt"></i>
                            </a>

                        </div>
                    </div>
                </div>

                <div class="share row" v-if="loggedUser">
                    <div class="col d-flex align-items-center">
                        <a @click="showMailModal">
                            {{ $language.share }}&nbsp;<i class="fas fa-share-alt"></i>
                        </a>
                    </div>
                </div>
            </aside>


        </div>

    `,
    data: function() {
        return {
            showCompetitors: false,
            showCpcs: false,
            showAssignees: false,
            showInventors: false,
            loggedUser: loggedUser,
        };
    },

    mounted() {
        $('[data-toggle="tooltip"]').tooltip();
    },

    computed: {
        family() {
            return this.$route.params.family;
        },
        classes() {
            return this.$store.getters.classes;
        }
    },

    methods: {

        openExplorer: function() {
            console.log(this.$setupPath + '../familyExplorer/public/index.php?fn=' + this.family);
            window.open(
                '/' + this.$setupPath + '../familyExplorer/public/index.php?fn=' + this.family,
                // 'https://www.patbase.com/getimg/ipc/fx.asp?id=' + this.family,
                'explorer_popup',
                'resizable=yes,scrollbars=yes,location=no,menubar=yes,width=' + (screen.width - 50) + ',height=' + (screen.height - 150) + ',left=20,top=25'
            );
        },

        toggleCompetitors: function() {
            this.showCompetitors = !this.showCompetitors;
        },

        toggleCpcs: function() {
            this.showCpcs = !this.showCpcs;
        },

        toggleAssignees: function() {
            this.showAssignees = !this.showAssignees;
        },

        toggleInventors: function() {
            this.showInventors = !this.showInventors;
        },

        showMailModal() {
            $(this.$refs.mailModal).modal('toggle');
            EventBus.$emit('showShare');
        }
    }
});
